<template>
  <div class="order">
    <back-home-btn></back-home-btn>

    <v-container class="pa-3 pt-5">
      <v-row>
        <!-- 注文内容 -->
        <v-col cols="12" class="pa-0">
          <v-container class="py-0">
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-tabs
                    v-model="tab"
                    background-color="primary"
                    center-active
                    dark
                    show-arrows
                  >
                    <v-tab
                      ><v-icon small>{{
                        tab > 0 && cart.length > 0
                          ? 'mdi-check-circle-outline'
                          : 'mdi-numeric-1-circle-outline'
                      }}</v-icon
                      >カートの中を確認する</v-tab
                    >
                    <v-tab
                      ><v-icon small>{{
                        tab > 1 && deliveryInfo && deliveryInfo.entered
                          ? 'mdi-check-circle-outline'
                          : 'mdi-numeric-2-circle-outline'
                      }}</v-icon
                      >配送方法を選択する</v-tab
                    >
                    <v-tab
                      ><v-icon small>{{
                        tab > 2 && paymentInfo && paymentInfo.entered
                          ? 'mdi-check-circle-outline'
                          : 'mdi-numeric-3-circle-outline'
                      }}</v-icon
                      >支払方法を選択する</v-tab
                    >
                    <v-tab
                      ><v-icon small>{{
                        tab > 3 && (authUser || email != '')
                          ? 'mdi-check-circle-outline'
                          : 'mdi-numeric-4-circle-outline'
                      }}</v-icon
                      >その他</v-tab
                    >
                    <v-tab
                      ><v-icon small>mdi-numeric-5-circle-outline</v-icon
                      >注文する</v-tab
                    >
                  </v-tabs>
                </v-card>

                <v-tabs-items v-model="tab" class="pa-3">
                  <!-- カートの中身 -->
                  <v-tab-item>
                    <div class="text-body-2">
                      購入する商品を確認して「次へ」を押下してください。
                    </div>
                    <v-divider></v-divider>
                    <cart-contents
                      :cart="cart"
                      :show-empty-message="totalQty <= 0"
                      :merch-sub-total="merchSubTotal"
                      @increment-qty-click="incrementQty"
                      @decrement-qty-click="decrementQty"
                      @remove-item-click="removeItem"
                      @clear-cart-click="clearCart"
                    ></cart-contents>
                    <div class="mt-5" align="end">
                      <v-btn
                        color="primary"
                        :disabled="cart.length == 0"
                        @click="tab = 1"
                      >
                        次へ
                      </v-btn>
                    </div>
                  </v-tab-item>
                  <!-- 配送方法 -->
                  <v-tab-item>
                    <div class="text-body-2">
                      配送方法を選択して送料が確定したら「次へ」を押下してください。
                    </div>
                    <v-divider></v-divider>
                    <delivery-select
                      ref="deliverySelect"
                      :delivery-direct="DELIVERY_DIRECT"
                      :delivery-youpack="DELIVERY_YOUPACK"
                      :exist-sp-price="existSpPrice"
                      :exist-group="existGroup"
                      :group="group"
                      :show-address-list-btn="showAddressListBtn"
                      :load-address-list-action="loadAddressList"
                      :address-lists="addressLists"
                      :calc-postage-action="calcPostage"
                      :packings="packings"
                      :postage-sub-total="postageSubTotal"
                      @info-changed="setDeliveryInfo"
                      @postage-confirm-canceled="clearPackings"
                    ></delivery-select>
                    <v-row class="mt-5" justify="space-between">
                      <v-col>
                        <v-btn text @click="tab = 0">
                          戻る
                        </v-btn>
                      </v-col>
                      <v-col class="text-end">
                        <v-btn
                          color="primary"
                          :disabled="deliveryInfo && !deliveryInfo.entered"
                          @click="tab = 2"
                        >
                          次へ
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <!-- 支払方法 -->
                  <v-tab-item>
                    <div class="text-body-2">
                      支払方法を選択して「次へ」を押下してください。
                    </div>
                    <v-divider></v-divider>
                    <payment-select
                      ref="paymentSelect"
                      :payment-credit="PAYMENT_CREDIT"
                      :payment-transfer="PAYMENT_TRANSFER"
                      :payment-cash="PAYMENT_CASH"
                      :exist-group="existGroup"
                      :cash-btn-disabled="disableCashBtn"
                      :stripe-public-key="stripePublicKey"
                      @info-changed="setPaymentInfo"
                    ></payment-select>
                    <v-row class="mt-5" justify="space-between">
                      <v-col>
                        <v-btn text @click="tab = 1">
                          戻る
                        </v-btn>
                      </v-col>
                      <v-col class="text-end">
                        <v-btn
                          color="primary"
                          :disabled="paymentInfo && !paymentInfo.entered"
                          @click="tab = 3"
                        >
                          次へ
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <!-- その他 -->
                  <v-tab-item>
                    <div class="text-body-2">
                      必要に応じて入力し「次へ」を押下してください。
                    </div>
                    <v-divider></v-divider>
                    <!-- 領収書依頼 -->
                    <v-container>
                      <v-checkbox
                        v-model="receiptRequired"
                        label="領収書を依頼する"
                      ></v-checkbox>
                      <v-text-field
                        v-if="receiptRequired"
                        dense
                        label="領収書名"
                        v-model="receiptName"
                        ref="receiptName"
                      ></v-text-field>
                    </v-container>
                    <!-- 備考 -->
                    <v-container>
                      <v-textarea
                        dense
                        label="配達時間指定などのご希望がある場合はこちらに記載してください"
                        v-model="remarks"
                        ref="remarks"
                      ></v-textarea>
                    </v-container>
                    <!-- ゲスト注文用メールアドレス入力 -->
                    <v-container v-if="!authUser" class="pt-0">
                      <div class="text-caption red--text">
                        ゲストのご購入は注文確認連絡用のメールアドレス入力が必要です
                      </div>
                      <v-text-field
                        ref="email"
                        v-model="email"
                        prepend-icon="mdi-email"
                        :rules="[
                          rules.required,
                          rules.emailLength,
                          rules.email,
                        ]"
                        label="連絡先メールアドレス"
                      ></v-text-field>
                    </v-container>
                    <v-row class="mt-5" justify="space-between">
                      <v-col>
                        <v-btn text @click="tab = 2">
                          戻る
                        </v-btn>
                      </v-col>
                      <v-col class="text-end">
                        <v-btn
                          color="primary"
                          :disabled="!authUser && email == ''"
                          @click="tab = 4"
                        >
                          次へ
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <!-- 最終確認 -->
                  <v-tab-item>
                    <div class="text-body-2">
                      お支払額を確認して「注文を確定する」ボタンを押下してください
                    </div>
                    <v-divider></v-divider>
                    <div class="text-body-2 mt-5">注文内容</div>
                    <v-divider></v-divider>
                    <template v-for="(item, index) in cart">
                      <v-row no-gutters :key="index">
                        <v-col cols="12" sm="6" class="text-body-2"
                          >{{ item.merchandiseName }} -
                          {{ item.typeName }}</v-col
                        >
                        <v-col cols="8" sm="3" class="text-caption text-end"
                          >数量:{{ item.qty }}</v-col
                        >
                        <v-col cols="4" sm="3" class="text-caption text-end">
                          {{ item.amount | toPriceFormat }}</v-col
                        >
                      </v-row>
                    </template>
                    <v-row no-gutters>
                      <v-col cols="8" sm="9" align="end" class="text-body-2"
                        >商品小計:</v-col
                      >
                      <v-col cols="4" sm="3" align="end" class="text-body-2">{{
                        merchSubTotal | toPriceFormat
                      }}</v-col>
                    </v-row>
                    <div class="text-body-2 mt-5">配送方法</div>
                    <v-divider></v-divider>
                    <template v-if="deliveryInfo && deliveryInfo.entered">
                      <v-row no-gutters>
                        <v-col cols="12" class="text-body-2"
                          >**
                          {{
                            deliveryInfo.delivery == DELIVERY_YOUPACK
                              ? 'ヤマト運輸配送'
                              : 'グループ / 直接配達'
                          }}
                          **</v-col
                        >
                      </v-row>
                      <template
                        v-if="deliveryInfo.delivery == DELIVERY_YOUPACK"
                      >
                        <v-row no-gutters>
                          <template v-for="(packing, index) in packings">
                            <v-col
                              cols="12"
                              sm="6"
                              class="text-body-2"
                              :key="`name${index}`"
                            >
                              {{ packing.packing_name }} (サイズ{{
                                packing.youpack_size
                              }}<span class="red--text">{{
                                packing.overweight ? '*' : ''
                              }}</span
                              >)
                            </v-col>
                            <v-col
                              align="end"
                              cols="8"
                              sm="3"
                              class="text-caption"
                              :key="`qty${index}`"
                            >
                              数量:{{ packing.qty }}
                            </v-col>
                            <v-col
                              align="end"
                              cols="4"
                              sm="3"
                              class="text-caption"
                              :key="`amount${index}`"
                            >
                              {{ packing.amount | toPriceFormat }}
                            </v-col>
                            <v-col
                              v-if="packing.overweight"
                              cols="12"
                              class="text-caption red--text"
                              :key="`overwight${index}`"
                            >
                              *重量ヤマト運輸対象です
                            </v-col>
                          </template>
                        </v-row>
                      </template>
                      <v-row no-gutters>
                        <v-col cols="8" sm="9" align="end" class="text-body-2"
                          >送料小計:</v-col
                        >
                        <v-col
                          cols="4"
                          sm="3"
                          align="end"
                          class="text-body-2"
                          v-if="showPostageSubTotal"
                          >{{ postageSubTotal | toPriceFormat }}</v-col
                        >
                        <v-col
                          cols="4"
                          sm="3"
                          align="end"
                          class="text-body-2"
                          v-else
                          >(未算出です)</v-col
                        >
                      </v-row>
                      <v-row no-gutters class="mt-3">
                        <v-col cols="12" class="text-caption">(お届け先)</v-col>
                        <v-col cols="12" class="text-caption"
                          >〒{{ deliveryInfo.destination_zip }}
                          {{ deliveryInfo.destination_address }}</v-col
                        >
                        <v-col cols="8" sm="3" class="text-caption"
                          >{{ deliveryInfo.destination_name }} 様</v-col
                        >
                        <v-col cols="4" sm="3" class="text-caption">{{
                          deliveryInfo.destination_tel
                        }}</v-col>
                      </v-row>
                    </template>
                    <div v-else class="text-body-2">
                      配送方法が未決定です
                    </div>
                    <div class="text-body-2 mt-5">支払方法</div>
                    <v-divider></v-divider>
                    <template v-if="paymentInfo && paymentInfo.entered">
                      <v-row no-gutters>
                        <v-col cols="12" class="text-body-2"
                          >**
                          {{
                            paymentInfo.payment == PAYMENT_CREDIT
                              ? 'クレジットカード決済'
                              : paymentInfo.payment == PAYMENT_TRANSFER
                              ? '銀行振込'
                              : '配達時支払い（現金）'
                          }}
                          **</v-col
                        >
                      </v-row>
                    </template>
                    <div v-else class="text-body-2">
                      支払方法が未決定です
                    </div>
                    <div class="text-body-2 mt-5">領収書</div>
                    <v-divider></v-divider>
                    <div
                      v-if="receiptRequired && receiptName != ''"
                      class="text-body-2"
                    >
                      {{ receiptName }} 様
                    </div>
                    <div
                      v-else-if="receiptRequired && receiptName == ''"
                      class="text-body-2"
                    >
                      領収書名が入力されていません
                    </div>
                    <div v-else class="text-body-2">
                      不要
                    </div>
                    <template v-if="remarks">
                      <div class="text-body-2 mt-5">配達希望など</div>
                      <v-divider></v-divider>
                      <div class="text-body-2">
                        {{ remarks }}
                      </div>
                    </template>
                    <template v-if="!authUser">
                      <div class="text-body-2 mt-5">連絡先メールアドレス</div>
                      <v-divider></v-divider>
                      <div v-if="email != ''" class="text-body-2">
                        {{ email }}
                      </div>
                      <div v-else class="text-body-2">
                        メールアドレスが入力されていません
                      </div>
                    </template>

                    <!-- 注文操作 -->
                    <order-execute
                      class="mt-5"
                      ref="orderExecute"
                      :show-postage-sub-total="showPostageSubTotal"
                      :merch-sub-total="merchSubTotal"
                      :postage-sub-total="postageSubTotal"
                      :total-amount="totalAmount"
                      :order-button-disabled="orderButtonDisabled"
                      :execute-order-action="executeOrder"
                      :order-error="errMsg"
                      @complete-message-close="gotoTop"
                    >
                    </order-execute>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-container>
        </v-col>

        <!-- 注文操作 -->
        <!-- <v-col
          cols="12" sm="12" md="4" lg="4" 
        >
          
        </v-col> -->
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as ordersApi from '../api/modules/orders';
import * as paymentApi from '../api/modules/payment';
import {
  DeliveryMethods,
  PaymentMethods,
  SalesMedia,
  OrderStatuses,
  HttpStatuses,
} from '../constants/komegura-config';
import { buildOrderDetails } from '../utils/orderBuilder';
import { emailValidationRules, isValidEmail } from '../utils/validators';
import { isSuccessStatus } from '../utils/http';
import CartContents from '../components/feature/CartContents.vue';
import DeliverySelect from '../components/feature/DeliverySelect.vue';
import PaymentSelect from '../components/feature/PaymentSelect.vue';
import OrderExecute from '../components/feature/OrderExecute.vue';
import BackHomeBtn from '../components/common/BackHomeBtn.vue';

const stripePublic = process.env.VUE_APP_STRIPE_PUBLIC;

export default {
  components: {
    CartContents,
    DeliverySelect,
    PaymentSelect,
    OrderExecute,
    BackHomeBtn,
  },
  data: () => ({
    // 配送情報
    deliveryInfo: null,
    // 支払方法
    paymentInfo: null,
    // 領収書
    receiptRequired: false,
    receiptName: '',
    // メールアドレス
    email: '',
    rules: {
      ...emailValidationRules,
    },
    errMsg: null,
    tab: 0,
    remarks: '',
  }),
  computed: {
    ...mapGetters({
      // 認証ユーザー
      authUser: 'auth/authUser',
      // 顧客グループ情報
      group: 'auth/groupInfo',
      // カート
      cart: 'cart/cart',
      // 梱包
      packings: 'cart/packings',
      // カートの商品件数
      totalQty: 'cart/totalQty',
      // 商品金額小計
      merchSubTotal: 'cart/merchandiseSubTotal',
      // 送料合計
      postageSubTotal: 'cart/postageSubTotal',
      // サイズ別集計
      totalBySize: 'cart/totalBySize',
      // 特別価格商品存在チェック
      existSpPrice: 'cart/existSpPrice',
      // 個人アドレス帳
      addressLists: 'auth/addressLists',
    }),
    PAYMENT_CREDIT: () => PaymentMethods.CREDIT,
    PAYMENT_TRANSFER: () => PaymentMethods.TRANSFER,
    PAYMENT_CASH: () => PaymentMethods.CASH,
    DELIVERY_YOUPACK: () => DeliveryMethods.YOUPACK,
    DELIVERY_DIRECT: () => DeliveryMethods.DIRECT,
    STATUS_ORDER: () => OrderStatuses.ORDER,
    MEDIUM_SALES_APP: () => SalesMedia.SALES_APP,
    stripePublicKey: () => stripePublic,
    // 顧客グループ有無
    existGroup() {
      return this.authUser && this.authUser.customer_group ? true : false;
    },
    // アドレス帳ボタン表示判定
    showAddressListBtn() {
      return this.authUser ? true : false;
    },
    // 現金支払いボタン非活性判定
    disableCashBtn() {
      return this.deliveryInfo
        ? this.deliveryInfo.delivery == this.DELIVERY_YOUPACK
        : false;
    },
    // 送料小計表示判定
    showPostageSubTotal() {
      return this.deliveryInfo ? this.deliveryInfo.showPostageSubTotal : false;
    },
    // 合計金額
    totalAmount() {
      return this.merchSubTotal + this.postageSubTotal;
    },
    // 注文ボタンの非活性判定
    orderButtonDisabled() {
      // カートが空
      if (this.cart.length == 0) return true;

      if (this.deliveryInfo) {
        if (!this.deliveryInfo.entered) return true;
      }

      if (this.paymentInfo) {
        if (!this.paymentInfo.entered) return true;
      }

      if (!this.authUser) {
        if (this.email == '') return true;
        if (!isValidEmail(this.email)) return true;
      }

      return false;
    },
  },
  methods: {
    // 顧客グループ情報取得
    getGroupInfo() {
      if (!this.existGroup) return;

      this.$store.dispatch('auth/loadGroup');
    },
    // 商品数量加算
    incrementQty(item) {
      this.$store.dispatch('cart/incrementQty', item);
    },
    // 商品数量減算
    decrementQty(item) {
      this.$store.dispatch('cart/decrementQty', item);
    },
    // 商品をカートから削除
    removeItem(item) {
      this.$store.dispatch('cart/removeItem', item);
    },
    // カートを空にする
    clearCart() {
      this.$store.dispatch('cart/clearCart');
    },
    // 個人アドレス帳取得
    async loadAddressList() {
      // ストアに履歴が格納されていなければ取得
      if (!this.addressLists) {
        await this.$store.dispatch('auth/loadAddressLists', this.authUser.id);
      }
    },
    // 送料計算
    async calcPostage(area_id) {
      await this.$store.dispatch('cart/calcPostage', area_id);
    },
    // 梱包情報を解除
    clearPackings() {
      this.$store.dispatch('cart/clearPackings');
    },
    // 配送情報変更を反映
    setDeliveryInfo(info) {
      this.deliveryInfo = info;

      // ヤマト運輸配送が選択された時点で現地払いが選択されている際にクレカ払いを選択
      if (this.deliveryInfo) {
        if (
          this.deliveryInfo.delivery == this.DELIVERY_YOUPACK &&
          this.payment == this.PAYMENT_CASH
        ) {
          this.payment = this.PAYMENT_CREDIT;
        }
      }
    },
    // 支払い情報変更を反映
    setPaymentInfo(info) {
      this.paymentInfo = info;
    },
    // 注文実行
    async executeOrder() {
      if (!this.$refs.deliverySelect.validated()) return;

      if (!this.$refs.paymentSelect.validated()) return;

      if (!this.authUser) {
        if (!this.$refs.email.validate()) return;
      }
      this.errMsg = null;

      const customer_id = this.authUser ? this.authUser.id : 0;
      const destination_name = this.deliveryInfo.destination_name;
      const destination_zip = this.deliveryInfo.destination_zip;
      const destination_address = this.deliveryInfo.destination_address;
      const destination_tel = this.deliveryInfo.destination_tel;
      const contact_email = !this.authUser ? this.email : '';
      const area_id = this.deliveryInfo.area_id;
      const delivery_id = this.deliveryInfo.delivery;
      const payment_id = this.paymentInfo.payment;
      const receipt_required = this.receiptRequired;
      const receipt_name = this.receiptRequired ? this.receiptName : '';
      const receipt_amount = this.totalAmount;
      const status_id = this.STATUS_ORDER;
      const medium_id = this.MEDIUM_SALES_APP;
      const remarks = this.remarks;

      const details = buildOrderDetails(this.cart, this.packings);

      const order = {
        customer_id,
        destination_name,
        destination_zip,
        destination_address,
        destination_tel,
        contact_email,
        area_id,
        delivery_id,
        payment_id,
        receipt_required,
        receipt_name,
        receipt_amount,
        status_id,
        medium_id,
        remarks,
        details,
      };

      const result = await ordersApi.createOrder(order);

      if (isSuccessStatus(result.statusCode)) {
        // カード決済
        if (this.paymentInfo.payment == this.PAYMENT_CREDIT) {
          // ロールバック用にidを残す
          const id = result.response;
          const result2 = await paymentApi.createPaymentIntent(
            this.totalAmount,
          );

          try {
            if (isSuccessStatus(result2.statusCode)) {
              const data = result2.response;
              const client_secret = data.clientSecret;
              //client_secretを利用して（確認情報をStripeに投げて）決済を完了させる
              await this.paymentInfo.stripe
                .confirmCardPayment(client_secret, {
                  payment_method: {
                    card: this.paymentInfo.cardNumberElements,
                  },
                })
                .then(res => {
                  if (res.error) {
                    this.$refs.paymentSelect.setCardError(res.error.message);
                    throw new Error('カード決済に失敗');
                  } else {
                    // The payment succeeded!
                    this.orderComplete();
                  }
                });
            } else {
              this.$store.dispatch('error/setError', {
                code: result2.statusCode,
                id: result2.requestId,
                message: result2.response,
              });
              throw new Error('paymentIntent取得に失敗');
            }
          } catch (error) {
            // 注文データのロールバック
            const result3 = await ordersApi.cancelOrder(id);
            if (!isSuccessStatus(result3.statusCode)) {
              this.$store.dispatch('error/setError', {
                code: result3.statusCode,
                id: result3.requestId,
                message: result3.response,
              });
            }
          }
        } else {
          this.orderComplete();
        }
      } else if (result.statusCode == HttpStatuses.CONFLICT) {
        this.errMsg = '在庫切れのため購入できませんでした。';
      } else {
        this.$store.dispatch('error/setError', {
          code: result.statusCode,
          id: result.requestId,
          message: result.response,
        });
      }
    },
    // 注文完了
    orderComplete() {
      this.clearCart();
      this.$refs.orderExecute.orderComplete();
      this.$store.dispatch('auth/loadOrderHistories');
      this.$store.dispatch('auth/clearAddressLists');
    },
    // トップに戻る
    gotoTop() {
      this.$router.push('/').catch(() => {});
    },
  },
  created() {
    this.$store.dispatch('cart/clearPackings');

    // ストアにグループ情報が格納されていなかったら取得
    if (!this.group) {
      this.getGroupInfo();
    }
  },
  watch: {
    authUser: function() {
      this.getGroupInfo();
    },
    totalQty: function() {
      if (this.$refs.deliverySelect)
        this.$refs.deliverySelect.resetPostageConfirm();
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .v-avatar {
    display: none;
  }
}
</style>
